var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertIcon = function SvgAlertIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.762,
    d: "M10.001 7.794v3.133m0 2.35h.008m-1.29-9.72-6.35 10.6a1.5 1.5 0 0 0 1.282 2.25h12.7a1.5 1.5 0 0 0 1.281-2.249L11.283 3.556a1.498 1.498 0 0 0-2.564.001"
  })));
};
export default SvgAlertIcon;